<app-steps-header></app-steps-header>
<div class="bg-abi-light min-vh-100 d-flex flex-column py-5">
	<div class="container px-0 flex-grow-1">
		<div class="col-12 d-flex justify-content-center">
			<img [src]="errorImageUrl" class="success-img" alt="success-verifica" />
		</div>
		<div class="col-12 d-flex justify-content-center text-center mt-3 mt-md-5">
			<div class="bg-abi-secondary-light alert">
				<i class="bi bi-x"></i>
			</div>
		</div>
		<div class="mx-5 mx-md-0">
			<div class="col-12 d-flex justify-content-center text-center mt-4">
				<h1 class="text-abi-dark fw-bold fs-20">{{isPagamentoAnnullato ? ('pagAnnullato' | translate) : ('nessunImporto' | translate)}}</h1>
				<!-- ('opsErrore' | translate) -->
			</div>
			<div class="col-12 d-flex justify-content-center text-center mt-0 mt-md-3 mb-4">
				<span class="text-abi-dark fw-bold fs-15">
					{{isPagamentoAnnullato ? ('pagAnnullatoLong' | translate) :
						is404 ? ('pagina404' | translate) : ''
					}}
					<!-- ('qualcosaStorto' | translate) -->
					<br />
					<!-- @if(!is404) {
						<span class="fw-light">
							{{isPagamentoAnnullato ? ('controllaDettagli' | translate) : ('contattaAssistenza' | translate)}}
						</span>
					} -->
				</span>
			</div>
		</div>
		<div class="col-12 d-flex justify-content-center">
			@if (hasOrdine) {
				<button class="btn btn-abi-primary mx-5" type="button" (click)="tornaIndietro(false)">
					{{'Riprova' | translate}}
					<i class="bi bi-arrow-right-short fs-16 ms-1"></i>
				</button>
			} @else {
				<button class="btn btn-abi-primary mx-5" type="button" (click)="tornaIndietro(true)">
					{{'Torna al sito' | translate}}
					<i class="bi bi-arrow-right-short fs-16 ms-1"></i>
				</button>
			}
		</div>
	</div>

	<!-- Footer -->
	<div class="container px-2 px-md-0 col-12 d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between align-items-center mt-4 gap-2">
		<span class="text-abi-dark fs-11 fw-100 text-center text-lg-start">
			@if (isImatra) {
				Imatra - PIB Italia broker © 2026 | All rights reserved
			} @else {
				PIB Italia broker © 2026 | All rights reserved
			}
		</span>
		<div class="d-flex align-items-center gap-2">
			@if (isImatra) {
				<div class="d-flex align-items-center gap-3">
					<img src="/assets/img/imatra/logo.svg" alt="Imatra" class="landing-logo-footer" />
					<span class="landing-header-divider">|</span>
					<div class="d-flex flex-column align-items-start gap-1">
						<span class="landing-footer-powered-dark">Powered by</span>
						<img src="/assets/images/logo_pib.svg" alt="PIB Italia broker" class="landing-logo-pib-footer" />
					</div>
				</div>
			} @else {
				<div class="d-flex align-items-center gap-3">
					<img src="/assets/images/PIB Italia Broker_logo.png" alt="PIB Group" class="landing-logo-xl" />
					<span class="landing-header-divider">|</span>
					<div class="d-flex align-items-center gap-2">
						<span class="landing-footer-powered-dark">IN PARTNERSHIP WITH</span>
						<img src="/assets/img/aic/logo.png" alt="AIC" class="landing-logo-footer landing-logo-circle bg-white p-1" />
					</div>
				</div>
			}
		</div>
		<app-change-language class="only-desktop"></app-change-language>
	</div>
</div>
